import Button from 'components/button-new';
import ImpressionTrackerNew from 'components/impression-tracker/new-impression-tracker';
import { ISlideRedesignFields } from 'global';
import renderDocument from 'modules/content-cms/util/render-document';
import React from 'react';
import Link from 'next/link';
import { selectElement } from 'tracking';
import { gtm } from 'tracking/gtm';
import Image from '../../components/image';

interface SlideNewDesignProps extends ISlideRedesignFields {
  trackingName: string;
  priority?: boolean;
}

/**
 * New promo header for slider. Smaller design to be contained within first view port
 * @See : https://petsdeli.atlassian.net/browse/PT-4789
 */
const SlideNewDesign: React.FC<SlideNewDesignProps> = ({
  backgroundColour,
  ctaText,
  fullScreenImage,
  image,
  laptopImage,
  link,
  priority,
  text,
  textColor = '#19335A',
  title,
  trackingName,
  backgroundColourHexCode,
}) => {
  const desktopImage = fullScreenImage || laptopImage;

  return (
    <ImpressionTrackerNew element={[trackingName, title]}>
      <Link
        href={link}
        className="lg:relative"
        aria-label={title}
        onClick={() => {
          gtm(
            selectElement({
              element: [trackingName, title],
            })
          );
        }}
      >
        {laptopImage && (
          <div className="relative hidden h-[450px] w-full lg:block">
            <Image
              priority={priority}
              data-test="promo-header-dt"
              layout={'fill'}
              objectFit={'cover'}
              {...desktopImage}
            />
          </div>
        )}
        {image && (
          <div className="relative h-52 lg:hidden">
            <Image
              data-test="promo-header-mb"
              layout={'fill'}
              objectFit={'cover'}
              {...image}
            />
          </div>
        )}

        <div
          className={`top-0 right-0 flex flex-col gap-2.5 p-4 lg:absolute bg-new-brand-${backgroundColour} lg:mt-32 lg:mr-20 lg:w-[480px] lg:rounded-sm`}
          style={{ backgroundColor: backgroundColourHexCode }}
        >
          <div
            style={{ color: textColor }}
            className="line-clamp-2 font-black lg:line-clamp-3"
          >
            {title}
          </div>
          <div
            style={{ color: textColor }}
            className="line-clamp-3 lg:line-clamp-5"
          >
            {text && renderDocument(text)}
          </div>
          <Button as="div" size="base">
            {ctaText}
          </Button>
        </div>
      </Link>
    </ImpressionTrackerNew>
  );
};

export default SlideNewDesign;
